import { Box, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const BOOKING_FORM_PATHS = [
  "/book/cleaning/general-cleaning",
  "/book/aircon/general-servicing",
];

export default function OfflineBanner() {
  const { pathname } = useLocation();
  const isBookingPage = BOOKING_FORM_PATHS.includes(pathname);
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [showReconnected, setShowReconnected] = useState(false);

  useEffect(() => {
    let reconnectTimer: ReturnType<typeof setTimeout>;

    const handleOnline = () => {
      setIsOnline(true);
      setShowReconnected(true);
      reconnectTimer = setTimeout(() => setShowReconnected(false), 2000);
    };
    const handleOffline = () => {
      clearTimeout(reconnectTimer);
      setIsOnline(false);
      setShowReconnected(false);
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      clearTimeout(reconnectTimer);
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  if (isOnline && !showReconnected) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex={9999}
      bg={isOnline ? "#16a34a" : "#d97706"}
      color="white"
      textAlign="center"
      py="0.45rem"
      px="1rem"
    >
      <Text fontSize="sm" fontWeight="600" fontFamily="Montserrat Variable, system-ui, sans-serif">
        {isOnline
          ? "Back online — your connection has been restored."
          : isBookingPage
            ? "⚠  You're offline — your booking details are saved."
            : "⚠  You're offline."}
      </Text>
    </Box>
  );
}
